import React from 'react'
import cn from 'clsx'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { rem } from 'polished'
import { accountAccessShowLogin } from 'actions/UiActions'
import Spacing from 'components/Common/Spacing'
import SocialButtons from 'components/Account/AccountAccess/AccountAccessSocialButtons'
import { mediaQueryUp } from 'components/utils/breakpoint'
import SocialStars from 'components/Common/SocialStars/SocialStars'
import TextButton from 'components/Luxkit/Button/TextButton'
import TextLink from 'components/Luxkit/TextLink'
import Heading from 'components/Luxkit/Typography/Heading'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Wrapper = styled.div`
  background-color: ${props => props.theme.palette.neutral.default.eight};
  padding: ${rem(30)} ${rem(25)} ${rem(25)};

  ${mediaQueryUp.desktop} {
    margin-left: auto;
    max-width: ${rem(360)};

    // bandaid fix for centering hub page modal until design & marketing update
    &.hub {
      margin: auto;
    }
  }
`

interface Props {
  title: string;
  prefix?: string;
  className?: string;
  accountAccessShowLogin: () => void;
  isStoreMode: boolean;
  version?: string;
}

function SignUpBox(props: Props) {
  return !props.isStoreMode && <Wrapper className={cn(props.className, props.version)}>
    <Heading variant="heading5" align="center">
      Get exclusive offers to amazing destinations
    </Heading>

    <SocialStars prefix={props.prefix} />

    <Spacing mt={25} pl={20} pr={20}>
      <SocialButtons mode="join" renderId={props.prefix ? `signUpBox-${props.prefix}` : 'signUpBox'} hideText inline/>

      <Spacing mt={10}>
        <TextButton
          kind="primary"
          onClick={() => props.accountAccessShowLogin()}
          fit="flex"
        >
          Sign up with email
        </TextButton>
      </Spacing>

      <Spacing mt={15}>
        <BodyText variant="large" align="center">
          Already have an account? {' '}
          <TextLink onClick={() => props.accountAccessShowLogin()}>
            Log in
          </TextLink>
        </BodyText>
      </Spacing>
    </Spacing>
  </Wrapper>
}

function mapStateToProps(state: App.State) {
  return {
    isStoreMode: state.config.storeMode,
  }
}

const mapDispatchToProps = {
  accountAccessShowLogin,
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpBox)
